import type { Dispatch, FC, SetStateAction } from "react";
import { useMemo } from "react";

import type { ICategoryItem } from "app/components/React/CategoriesDropdown/CategoryDropdown";
import { CategoryDropdown } from "app/components/React/CategoriesDropdown/CategoryDropdown";
import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";

import { formatCategoryName } from "../../../helpers";
import { createLobCategories } from "../utils";

import { HeaderContainer, LobCategoryItemWrapper, StyledNoBorderButton } from "./styledComponents";

interface LobCategoryItemProps {
    text: string;
    visitsText: string;
    onClick?: () => void;
    selected?: boolean;
}
const LobCategoryItem: FC<LobCategoryItemProps> = ({ text, visitsText, onClick, selected }) => {
    return (
        <LobCategoryItemWrapper
            isSelected={selected}
            onClick={onClick}
        >
            <span>{text}</span>
            {visitsText ? <span>{visitsText}</span> : null}
        </LobCategoryItemWrapper>
    );
};
interface CategorySelectDropdownProps {
    selectedLob: string;
    onCategoryClicked: Dispatch<SetStateAction<string>>;
    availableLobs: string[];
    lobVisitsData?: Record<string, number>;
}

const CategorySelectDropdown: FC<CategorySelectDropdownProps> = ({
    availableLobs,
    selectedLob,
    onCategoryClicked,
    lobVisitsData,
}) => {
    const CategoryButton = ({ isPlaceholder, ...props }) => {
        return (
            <StyledNoBorderButton
                isPlaceholder={isPlaceholder}
                {...props}
            >
                {formatCategoryName(selectedLob)}
            </StyledNoBorderButton>
        );
    };

    const handleCategoryDropToggle = (isOpen: boolean) => {
        allTrackers.dispatchTrackEvent("dropdown", isOpen ? "open" : "close", "over time");
    };

    const handleCategorySelect = (category: ICategoryItem) => {
        onCategoryClicked(category.id);
    };

    const categories = useMemo(() => createLobCategories(availableLobs, lobVisitsData), [availableLobs, lobVisitsData]);

    const hasValidSelection = selectedLob && categories.length > 0;

    return (
        <HeaderContainer>
            <div>{translate("analysis.content.visits.overtime.title.comare")}</div>
            {hasValidSelection ? (
                <CategoryDropdown
                    selectedCategoryId={selectedLob}
                    searchPlaceHolder={translate("analysis.content.lob.dropdown.search.placeholder")}
                    onSelect={handleCategorySelect}
                    categoryButtonComponent={CategoryButton}
                    categoryItemComponent={LobCategoryItem}
                    categories={categories}
                    onToggle={handleCategoryDropToggle}
                    dropdownPopupHeight={200}
                    dropdownPopupMinScrollHeight={100}
                    buttonWidth="auto"
                    width={320}
                />
            ) : null}
        </HeaderContainer>
    );
};

export default CategorySelectDropdown;
